/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Status_StartingInputs */

const en_work_order_import_status_starting = /** @type {(inputs: Work_Order_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting import...`)
};

const fr_work_order_import_status_starting = /** @type {(inputs: Work_Order_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrage de l’importation...`)
};

const de_work_order_import_status_starting = /** @type {(inputs: Work_Order_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import wird gestartet...`)
};

const it_work_order_import_status_starting = /** @type {(inputs: Work_Order_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio importazione...`)
};

const ru_work_order_import_status_starting = /** @type {(inputs: Work_Order_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало импорта...`)
};

const es_work_order_import_status_starting = /** @type {(inputs: Work_Order_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando importación...`)
};

const zh_cn2_work_order_import_status_starting = /** @type {(inputs: Work_Order_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始导入...`)
};

const ja_work_order_import_status_starting = /** @type {(inputs: Work_Order_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インポートを開始しています...`)
};

const hi_work_order_import_status_starting = /** @type {(inputs: Work_Order_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात शुरू हो रहा है...`)
};

const pt_pt2_work_order_import_status_starting = /** @type {(inputs: Work_Order_Import_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando a importação...`)
};

/**
* | output |
* | --- |
* | "Starting import..." |
*
* @param {Work_Order_Import_Status_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_status_starting = /** @type {((inputs?: Work_Order_Import_Status_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Status_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_import_status_starting(inputs)
	if (locale === "de") return de_work_order_import_status_starting(inputs)
	if (locale === "it") return it_work_order_import_status_starting(inputs)
	if (locale === "ru") return ru_work_order_import_status_starting(inputs)
	if (locale === "es") return es_work_order_import_status_starting(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_import_status_starting(inputs)
	if (locale === "ja") return ja_work_order_import_status_starting(inputs)
	if (locale === "hi") return hi_work_order_import_status_starting(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_import_status_starting(inputs)
	return en_work_order_import_status_starting(inputs)
});